import React, { memo } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { Container, HeadingText, Link, BodyText } from '@paypalcorp/pp-react'
import { businessPageConfig, homeConfig } from '../../config/privacy-hub'
import PrivacyHubHeader from '../../components/privacyHub/privacy-hub-header'

const faqSection = (data) => {
  const { enabled, title, desc1, desc2, desc3, id } = data
  if (!enabled) {
    return null
  }
  return (
    <>
      <HeadingText
        id={id}
        className="privacy-hub-text privacy-hub-business-faq-question"
        level={2}
      >
        <Message id={title} />
      </HeadingText>
      <BodyText
        className="privacy-hub-text privacy-hub-business-faq-answer"
        id={`${id}Desc1`}
      >
        <Message id={desc1} />
      </BodyText>
      {desc2 && (
        <BodyText
          className="privacy-hub-text privacy-hub-business-faq-answer"
          id={`${id}Desc2`}
        >
          <Message
            id={desc2}
            link={(innerMessage) => (
              <Link
                href="/webapps/mpp/ua/privacy-full"
                className="privacy-hub-hyper-link"
                id={`${id}BusinessLink`}
              >
                {innerMessage}
              </Link>
            )}
          />
        </BodyText>
      )}
      {desc3 && (
        <BodyText
          className="privacy-hub-text privacy-hub-business-faq-answer"
          id={`${id}Desc3`}
        >
          <Message id={desc3} />
        </BodyText>
      )}
    </>
  )
}

const PrivacyHubBusinessSection = memo(() => {
  return (
    <>
      <Container className="privacy-hub-section-container">
        <div className="privacy-hub-wrapper">
          <PrivacyHubHeader {...homeConfig.headerSection('bussinessFaq')} />
        </div>
      </Container>
    </>
  )
})

PrivacyHubBusinessSection.displayName = 'PrivacyHubBusinessSection'

const PrivacyHubFaqSection = memo(() => (
  <Container className="privacy-hub-section-container">
    <div className="privacy-hub-wrapper">
      <HeadingText
        className="privacy-hub-text privacy-hub-business-faq-heading"
        id="privacyhubBusinessFaqsHeading"
        level={3}
      >
        <Message id="privacyhub.business.faq.title" />
      </HeadingText>
      {businessPageConfig.fqs.map((accordion, index) => {
        return (
          <div
            key={index}
            className="privacy-hub-business-faq-gap privacy-hub-business-faq-question-alignment"
          >
            {faqSection(accordion)}
          </div>
        )
      })}
    </div>
  </Container>
))

PrivacyHubFaqSection.displayName = 'PrivacyHubFaqSection'

const PrivacyHubBusiness = memo(() => (
  <div id="privacy-hub-business">
    <PrivacyHubBusinessSection />
    <PrivacyHubFaqSection />
  </div>
))

PrivacyHubBusiness.displayName = 'PrivacyHubBusiness'

export default PrivacyHubBusiness
